export const routes = {
    path: 'parametros',
    name: 'Parametros',
    component: () => import('./Listagem.vue'),
    meta: {
        rules: ['PARAM-00'],
    },
    children: [
        {
            path: ':id',
            name: 'Parametros_Detalhar',
            component: () => import('./Detalhar.vue'),
            meta: {
                rules: ['PARAM-02'],
            },
        },
        {
            path: 'inserir',
            name: 'Parametros_Inserir',
            component: () => import('./Inserir.vue'),
            meta: {
                rules: ['PARAM-01'],
            },
        },
        {
            path: ':id/atualizar',
            name: 'Parametros_Atualizar',
            component: () => import('./Atualizar.vue'),
            meta: {
                rules: ['PARAM-03'],
            },
        },
    ],
};